import { useComparador } from '../context/ComparadorContext';

export default function BotaoComparar({ id }) {
  const { imoveisSelecionados, adicionarImovel, removerImovel } =
    useComparador();

  const estaSelecionado = imoveisSelecionados.includes(id);

  const handleClick = () => {
    if (estaSelecionado) {
      removerImovel(id);
    } else {
      adicionarImovel(id);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`mt-2 px-3 py-1 rounded text-sm font-medium transition-all duration-200 ${
        estaSelecionado
          ? 'bg-red-100 text-red-600 hover:bg-red-200'
          : 'bg-green-100 text-green-600 hover:bg-green-200'
      }`}
    >
      {estaSelecionado ? 'Remover' : '+ Comparar'}
    </button>
  );
}
